import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import glamorousIcon from '../shared/icons'
import { SuccessPopupSvg, AlertPopupSvg } from '../shared/icons/svg-images'
import getStoreErrorMsg from '../../graphql/getStoreErrorMsg'
import { graphql, withApollo } from 'react-apollo'
import _, { flowRight as compose } from 'lodash'
import { Message } from '@paypalcorp/worldready-react'

const PopupDiv = glamorous.div(
  {
    position: 'fixed',
    bottom: 0,
    margin: 0,
    height: '0',
    width: '100%',
    zIndex: '999',
    transition: '.3s ease-in-out',
  },
  (props) => {
    let styles = []
    if (props.showPopup) {
      if (props.status === 'error') {
        styles.push({
          height: '390px',
        })
      } else {
        styles.push({
          height: '366px',
        })
      }
    }
    return styles
  },
)

const PopupContainer = glamorous.div({
  maxWidth: '800px',
  margin: '0 auto',
  height: '100%',
  textAlign: 'center',
  backgroundImage: 'linear-gradient(287deg, #009cde, #003087)',
})

const Content = glamorous.div({
  margin: '0 121px',
  textAlign: 'center',
  '@media only screen and (max-width: 768px)': {
    margin: '0 24px',
  },
})

const StyledMessage = glamorous.div({
  textAlign: 'center',
  color: 'white',
  fontSize: '15px',
  fontWeight: '500',
  lineHeight: '1.2',
  letterSpacing: 0,
  marginBottom: '12px',
})

const ErrorMessage = glamorous.div(
  {
    fontSize: '18px',
    color: '#FFFFFF',
    textAlign: 'left',
    lineHeight: '1.33',
  },
  'vx_text-body-lg',
)

const CheckoutButton = glamorous.button({
  width: '270px',
  height: '48px',
  background: 'white',
  margin: '12px 0 12px 0',
  fontSize: '15px',
  fontWeight: '500',
  letterSpacing: 0,
  '@media only screen and (max-width: 768px)': {
    width: '271px',
  },
  ':hover': {
    background: 'white',
  },
})

const ContinueButton = glamorous.button('vx_btn', {
  width: '270px',
  height: '48px',
  borderRadius: '50px',
  borderColor: 'white',
  backgroundColor: 'transparent',
  margin: '12px 0 12px 0',
  marginLeft: '0',
  fontSize: '15px',
  fontWeight: '500',
  letterSpacing: 0,
  '@media only screen and (max-width: 768px)': {
    width: '271px',
  },
})

const SuccessICON = glamorousIcon({
  '& svg': { height: '102', width: '102' },
})

const AlertICON = glamorousIcon({
  '& svg': { height: '98', width: '98' },
})

SuccessICON.defaultProps = { svg: SuccessPopupSvg }
AlertICON.defaultProps = { svg: AlertPopupSvg }

const IconContainer = glamorous.div({
  paddingTop: '45px',
  paddingBottom: '21px',
  width: '120px',
  margin: '0 auto',
})

const Popup = (props) => {
  const storeErrorMsg = _.get(props.data, 'getStoreInfo.store_error_msg')
  return (
    <PopupDiv showPopup={props.showPopup} status={props.status}>
      <PopupContainer>
        {props.status === 'loading' && (
          <IconContainer style={{ paddingTop: '119px' }} id="icon">
            <div className="vx_spinner-large" />
          </IconContainer>
        )}
        {props.status === 'done' && (
          <div>
            <IconContainer id="icon">
              <SuccessICON />
            </IconContainer>
            <Content>
              <StyledMessage>
                <Message id="pages/product.product.itemAdded" />
              </StyledMessage>
              <div>
                <CheckoutButton
                  className="vx_btn vx_btn-secondary"
                  onClick={props.handleCheckout}
                  name="Checkout"
                  data-pagename={props.pagename}
                  data-pagename2={props.pagename2}
                >
                  <Message id="pages/product.product.checkout" />
                </CheckoutButton>
              </div>
              <div>
                <ContinueButton
                  onClick={props.handleContinueShopping}
                  name="Continue"
                  data-pagename={props.pagename}
                  data-pagename2={props.pagename2}
                >
                  <Message id="pages/product.product.continueShopping" />
                </ContinueButton>
              </div>
            </Content>
          </div>
        )}
        {props.status === 'error' && (
          <div>
            <IconContainer id="icon">
              <AlertICON />
            </IconContainer>
            <Content>
              <StyledMessage style={{ marginBottom: '24px' }}>
                <Message id="pages/error.error.header" />
              </StyledMessage>
              <ErrorMessage>
                {storeErrorMsg ? (
                  <div>{storeErrorMsg}</div>
                ) : (
                  <div>
                    <Message id="pages/error.error.text" />
                  </div>
                )}
              </ErrorMessage>
              <ErrorMessage>
                <Message id="pages/error.error.charges" />
              </ErrorMessage>
              <CheckoutButton
                style={{ marginTop: '24px' }}
                className="vx_btn vx_btn-secondary"
                onClick={props.handleContinueShopping}
                name="CheckoutError"
                data-pagename={props.pagename}
                data-pagename2={props.pagename2}
              >
                <Message id="pages/product.product.errorButton" />
              </CheckoutButton>
            </Content>
          </div>
        )}
      </PopupContainer>
    </PopupDiv>
  )
}

Popup.propTypes = {
  showPopup: PropTypes.bool,
  handleCheckout: PropTypes.func,
  handleContinueShopping: PropTypes.func,
  status: PropTypes.string.isRequired,
  data: PropTypes.shape({
    getStoreErrorMsg: PropTypes.shape({
      store_error_msg: PropTypes.string,
    }),
  }),
  pagename: PropTypes.string,
  pagename2: PropTypes.string,
}

const PopupWithGraphql = compose(withApollo, graphql(getStoreErrorMsg))(Popup)

export default PopupWithGraphql
